import React from 'react'

import { useIntl } from 'react-intl'
import BoxRecipient from './BoxRecipient'
import {
  RECIPIENTS_TEST_GROUP,
  RECIPIENTS_GROUP_FILTER,
  RECIPIENTS_ALL
} from 'Pages/EmailSendingWizard/const'
import StyledIconAll from './IconAll'
import StyledIconFilterGroup from './IconFilterGroup'
import StyledIconTestGroup from './IconTestGroup'
import { useRecoilValue } from 'recoil'
import { pageState } from 'Pages/EmailSendingWizard/recoil/state/page'
import {
  Grid,
  SpacingVertical,
  SPACING_8,
  SPACING_24,
  Title,
  TITLE_VARIANT_M
} from 'mailup-web-components'

const BoxRecipients = () => {
  const intl = useIntl()
  const { idTestDefault } = useRecoilValue(pageState)

  return (
    <>
      <Title variant={TITLE_VARIANT_M}>
        {intl.formatMessage({ id: 'Load.EmailSendingWizard.TitleRecipient' })}
      </Title>
      <SpacingVertical variant={SPACING_8} />
      <Grid data-mu-test='sending-wizard__recipients-cards-container' cols='3'>
        {idTestDefault && (
          <BoxRecipient
            recipient={RECIPIENTS_TEST_GROUP}
            title={intl.formatMessage({
              id:
                'Load.EmailSendingWizard.SelectRecipientsDescriptionItem1Title'
            })}
            description={intl.formatMessage({
              id: 'Load.EmailSendingWizard.SelectRecipientsDescriptionItem1New'
            })}
            icon={<StyledIconTestGroup />}
          />
        )}

        <BoxRecipient
          recipient={RECIPIENTS_GROUP_FILTER}
          title={intl.formatMessage({
            id: 'Load.EmailSendingWizard.SelectRecipientsDescriptionItem2Title'
          })}
          description={intl.formatMessage({
            id: 'Load.EmailSendingWizard.SelectRecipientsDescriptionItem2New'
          })}
          icon={<StyledIconFilterGroup />}
        />
        <BoxRecipient
          recipient={RECIPIENTS_ALL}
          title={intl.formatMessage({
            id: 'Load.EmailSendingWizard.SelectRecipientsDescriptionItem3Title'
          })}
          description={intl.formatMessage({
            id: 'Load.EmailSendingWizard.SelectRecipientsDescriptionItem3New'
          })}
          icon={<StyledIconAll />}
        />
      </Grid>
      <SpacingVertical variant={SPACING_24} />
    </>
  )
}

export default BoxRecipients
